import { HttpErrorResponse, HttpInterceptorFn, HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

/**
 * Interceptor de errores HTTP: si el backend responde 401 (JWT vencido o
 * inválido a mitad de sesión SPA, sin recarga), fuerza logout + redirect a
 * /login en vez de dejar la petición fallar en silencio (hallazgo crítico de
 * seguridad/UX, diagnóstico 2026-08-12 — hoy nada detectaba el token vencido
 * hasta que el usuario recargaba la página).
 *
 * Registro en main.ts: provideHttpClient(withInterceptors([authInterceptor, errorInterceptor]))
 */
export const errorInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((err: unknown) => {
      if (err instanceof HttpErrorResponse && err.status === 401 && router.url !== '/login') {
        auth.logout();
        router.navigate(['/login'], { queryParams: { session_expired: '1' } });
      }
      return throwError(() => err);
    })
  );
};
